import script from "./CartComments.vue?vue&type=script&setup=true&lang=js"
export * from "./CartComments.vue?vue&type=script&setup=true&lang=js"

import "./CartComments.vue?vue&type=style&index=0&id=4b177553&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b177553"]])

export default __exports__